export default "__VITE_ASSET__JD_nzE1b__"